import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  IconButton,
  useTheme
} from '@mui/material';
import {
  Description as BlankIcon,
  AutoAwesome as TemplateIcon,
  SmartToy as AIIcon,
   Close as CloseIcon
} from '@mui/icons-material';

const CreateSurveyModal = ({ open, onClose, onSelect }) => {
  const theme = useTheme();

  const options = [
    {
      id: 'blank',
      title: 'Blank survey',
      description: 'Start from scratch',
      icon: BlankIcon,
      color: theme.palette.primary.main
    },
    {
      id: 'template',
      title: 'Template',
      description: 'Pre-built designs',
      icon: TemplateIcon,
      color: theme.palette.secondary.main
    }
    // ,
    // {
    //   id: 'ai',
    //   title: 'Create with AI',
    //   description: 'Let AI help you design the perfect survey',
    //   icon: AIIcon,
    //   color: theme.palette.info.main
    // }
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2,
          position: 'relative'
        }
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: '1%',
          top: '1%',
          color: 'grey.500',
          zIndex: 1
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle 
        sx={{ 
          textAlign: 'center',
          pb: 3,
          color: theme.palette.text.primary,
          fontWeight: 500,
          fontSize: 32,

        }}
      >
        Choose how to get started
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          {options.map((option) => (
            <Grid 
              item 
              xs={12} 
              sm={6} 
              key={option.id}
              sx={{ pt: '44px !important' }}
            >
              <Card
                elevation={0}
                sx={{
                  height: '100%',
                  border: '1px solid',
                  borderColor: 'grey.200',
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    borderColor: option.color,
                    transform: 'translateY(-4px)',
                    boxShadow: `0 6px 20px ${option.color}20`
                  }
                }}
              >
                <CardActionArea
                  onClick={() => onSelect(option.id)}
                  sx={{
                    height: '100%',
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 2,
                      backgroundColor: `${option.color}10`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2
                    }}
                  >
                    <option.icon
                      sx={{
                        fontSize: 32,
                        color: option.color
                      }}
                    />
                  </Box>
                  <CardContent sx={{ textAlign: 'center', p: 0 }}>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        fontWeight: 500,
                        mb: 1,
                        color: theme.palette.text.primary
                      }}
                    >
                      {option.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                    >
                      {option.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CreateSurveyModal;